import { SignupInitialUserInput } from "@brexhq/next/types/brex-api";
import { createMockableHook } from "@brexhq/shared/utils/createMockableHook";

import { postToApi } from "./marketo";

export const signupMutation = async (input: SignupInitialUserInput) => {
  return postToApi(
    `mutation signupInitialUser($input: SignupInitialUserInput!) {
        signupInitialUser(input: $input) {
          result {
            customerUserId
            customerAccountId
            token
          }
          errors {
            code
            message
            path
          }
        }
      }`,
    {
      input,
    },
  );
};

export const _useSignupMutation = () => {
  const signup = async (input: SignupInitialUserInput) => {
    const response = await signupMutation(input);
    return response;
  };
  return { signup };
};

export const [useSignupMutation, MockUseSignupMutation] =
  createMockableHook(_useSignupMutation);
